module.exports = __webpack_public_path__ + "files/83cb2798c67a4efa3ac84c01a95d3c60.png";